import { Code } from '#app/components/typography/code'
import { H1 } from '#app/components/typography/h1.tsx'
import { H2 } from '#app/components/typography/h2.tsx'
import { P } from '#app/components/typography/p.tsx'
import { CodeBlock } from '#app/old/components/data-display/code-block'

export default function OverlaysRoute() {
	return (
		<>
			<H1>Overlays</H1>
			<P className="text-lg">Components that block interaction with the rest of the application.</P>

			<H2>Modals vs Dialog</H2>
			<P>
				"Modal" is sometimes used to mean "dialog", but this is incorrect. An element is considered modal if it blocks interaction with the rest of the application. A Dialog, on the
				other hand, is just one of many types of modals.
			</P>

			<H2>Modal Overlay Styling</H2>
			<P>
				All modals have an overlay container element that is typically a partially transparent element that covers the rest of the screen behind the modal, and prevents the user from
				interacting with the elements behind it.
			</P>
			<P>
				You can find the styles for the overlay in the <Code>component-styles.css</Code> file:
			</P>
			<CodeBlock
				className="mt-6"
				code={`/* ### Modals ### */
@layer components {
	/* Modal Overlay */
	.modal-overlay {
		@apply fixed inset-0 z-10 flex min-h-full items-center justify-center overflow-y-auto bg-muted-950/25 p-4 text-center backdrop-blur;
		&[data-entering] {
			@apply duration-300 ease-out animate-in fade-in;
		}
		&[data-exiting] {
			@apply duration-200 ease-in animate-out fade-out;
		}
	}

	/* Modal */
	.modal {
		@apply w-full max-w-md overflow-hidden rounded-2xl bg-background p-6 text-left align-middle shadow-xl;
		&[data-entering] {
			@apply duration-300 ease-out animate-in zoom-in-95;
		}
		&[data-exiting] {
			@apply duration-200 ease-in animate-out zoom-out-95;
		}
	}
}`}
				filename="component-styles"
				extension="css"
			/>
			<P>
				Notice the overlay supports entry and exit animations, exposed as <Code>[data-entering]</Code> and <Code>[data-exiting]</Code> DOM attributes that you can target with CSS
				selectors. Modal components will automatically wait for any exit animations to complete before removing the element from the DOM.
			</P>
		</>
	)
}
